import { useState } from "react";
import { Loading, Navbar } from "../components";
import { Link } from "react-router-dom";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <Loading />;
  }
  return (
    <section className="bg-black overflow-auto bg-hero">
      <Navbar />

      <form className="flex flex-col margin justify-center items-center padding">
        <h1 className="text-white mont font-bold sm:text-[32px] text-[21px] mb-[2rem]">
          Sign In
        </h1>
        <div className="flex flex-col gap-[2rem] md:w-[600px] w-full">
          <div className="flex flex-col gap-[10px] ">
            <p className="text-white xs:text-[20px] text-[17px] mont font-[600]">
              Email
            </p>
            <input
              type="email"
              required
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="outline-none border border-red w-full sm:h-[50px] h-[40px] bg-transparent sm:pl-[1.3rem] pl-[0.9rem] sm:text-[20px] text-[17px] mont font-bold text-white rounded-[7px]"
            />
          </div>

          <div className="flex flex-col gap-[10px] ">
            <p className="text-white xs:text-[20px] text-[17px] mont font-[600]">
              Password
            </p>
            <input
              type="password"
              required
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="outline-none border border-red w-full sm:h-[50px] h-[40px] bg-transparent sm:pl-[1.3rem] pl-[0.9rem] sm:text-[20px] text-[17px] mont font-bold text-white rounded-[7px]"
            />
          </div>
        </div>
        <button
          type="button"
          className="outline-none mont border-none py-2 sm:px-4  px-3 text-white bg-red mt-[2rem] sm:text-[22px] text-[18px] font-bold rounded-[5px] hover:bg-white hover:text-black  transition"
        >
          Sign In
        </button>

        <p className="text-white mont mt-[1rem] sm:text-[20px] text-[17px]">
          Don't have account?{" "}
          <Link
            className="text-red hover:underline poppins transition"
            to={"/create-account"}
          >
            Create Account
          </Link>
        </p>
        <p className="text-white mont mt-[1rem] sm:text-[20px] text-[17px]">
          By signing in you agree to our{" "}
          <Link
            className="text-red hover:underline poppins transition"
            to={"/terms-of-use"}
          >
            Terms of Use{" "}
          </Link>
          and our{" "}
          <Link
            className="text-red hover:underline poppins transition"
            to={"/privacy-policy"}
          >
            Privacy Policy
          </Link>
        </p>
      </form>
    </section>
  );
};

export default SignIn;
